import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { DateTimePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const styles = theme => ({
  noteField: {
    width: '100%',
    marginBottom: 20,
  },
  formControl: {
    width: '100%',
  },
});

class MentalHealthEditDialog extends React.Component {
  render() {
    const {
      t,
      classes,
      isOpen,
      onClose,
      onConfirm,
      onInputChange,
      onDatepickerChange,
      data,
      meta,
      dateFormat,
      displayNoTracker,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="mental-health-edit-dialog-title"
        aria-describedby="mental-health-edit-dialog-description"
        className="mental-health-edit-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="mental-health-edit-dialog-title">
          {t('Edit entry')}
        </DialogTitle>
        <DialogContent>
          <div>
            <TextField
              placeholder={t('Add note (optional)')}
              multiline
              rows="4"
              value={data.note}
              onChange={onInputChange}
              className={`mental-health-edit-dialog-note ${classes.noteField}`}
              name="editDialogData.note"
              margin="normal"
            />
          </div>
          <div>
            <Grid
              container
              spacing={4}
            >
              <Grid
                item
                md={6}
                sm={12}
              >
                <DateTimePicker
                  autoOk
                  ampm={false}
                  disableFuture
                  format={`${dateFormat} HH:mm`}
                  value={data.timestamp}
                  onChange={onDatepickerChange}
                  label={t('Timestamp')}
                  name="editDialogData.timestamp"
                  className={`mental-health-edit-dialog-timestamp ${classes.formControl}`}
                />
              </Grid>
              <Grid
                item
                md={6}
                sm={12}
              >
                {meta?.trackers && Object.keys(meta.trackers).length > 0 && (
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="tracker">
                      {t('Tracker')}
                    </InputLabel>
                    <Select
                      value={data.tracker}
                      onChange={onInputChange}
                      input={<Input name="editDialogData.tracker" />}
                      displayEmpty
                      name="editDialogData.tracker"
                      className="mental-health-edit-dialog-tracker"
                    >
                      {(
                        displayNoTracker ||
                        (
                          !displayNoTracker &&
                          data.tracker === ''
                        )
                      ) && (
                        <MenuItem value="">
                          <em>
                            <span>--</span>
                            {t('none')}
                            <span>--</span>
                          </em>
                        </MenuItem>
                      )}
                      {Object.keys(meta.trackers).map(trackerId => (
                        <MenuItem
                          key={trackerId}
                          value={trackerId}
                        >
                          {meta.trackers[trackerId]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            className="mental-health-edit-dialog-close-button"
          >
            {t('Close')}
          </Button>
          <Button
            onClick={onConfirm}
            color="primary"
            autoFocus
            className="mental-health-edit-dialog-save-button"
          >
            {t('Save')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(withStyles(styles)(MentalHealthEditDialog));
